export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5917.761dfdf6.jpg";